import { render, staticRenderFns } from "./ProductLeftBottomTag.vue?vue&type=template&id=549ad406&scoped=true&"
import script from "./ProductLeftBottomTag.vue?vue&type=script&lang=js&"
export * from "./ProductLeftBottomTag.vue?vue&type=script&lang=js&"
import style0 from "./ProductLeftBottomTag.vue?vue&type=style&index=0&id=549ad406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549ad406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('549ad406', component.options)
    } else {
      api.reload('549ad406', component.options)
    }
    module.hot.accept("./ProductLeftBottomTag.vue?vue&type=template&id=549ad406&scoped=true&", function () {
      api.rerender('549ad406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/common_components/tag/ProductLeftBottomTag.vue"
export default component.exports